import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state
) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                // If the user is authenticated...
                if (authenticated) {
                    const type = localStorage.getItem('type');

                    if (type === 'DEALER') {
                        return of(router.parseUrl('/dealer/dashboard'));
                    } else if (type === 'BUSINESS') {
                        return of(router.parseUrl('/corporate/dashboard'));
                    } else {
                        return of(router.parseUrl('/dashboard'));
                    }
                }

                // Allow the access
                return of(true);
            })
        );
};
